import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
    name: 'agprBypassURLSecurity',
    standalone: false
})
export class BypassURLSecurityPipe implements PipeTransform {

    constructor(
        private sanitizer: DomSanitizer
    ) {}

    /**
   * Allows the provided URL to bypass Angular URL security
  */
    transform(url): SafeResourceUrl {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);

    }

}
